import React from 'react';

/* Symbols */
import filterIcon from 'symbols/filter.svg';
import closeIcon from 'symbols/close.svg';

/* Components */
import VehicleOverviewFilter from './VehicleOverviewFilter';
import VehicleOverviewSearch from './VehicleOverviewSearch';
import VehicleOverviewToggles from "./VehicleOverviewToggles";
import VehicleOverviewSorting from './VehicleOverviewSorting';

/* Atoms */
import { Button } from 'js/components/atoms';

/* Organisms */
import { Modal } from 'js/components/organisms';

/* Utilities */
import { trans, animateCount } from 'js/utilities';

export default class VehicleOverviewHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstUpdate: true,
            resultsCount: this.props.totalResults,
            countAnimating: false
        };
    }

    componentDidUpdate(prevProps) {
        const { isDesktop, totalResults } = this.props;

        if (this.props.modalOpen && isDesktop && prevProps.isDesktop !== isDesktop) {
            this.props.setModalOpen(false);
        }

        if (prevProps.totalResults !== totalResults) {
            this.setState({ countAnimating: true });
            animateCount(
                prevProps.totalResults,
                totalResults,
                (newCount) => this.setState({ resultsCount: newCount }),
                () => this.setState({ countAnimating: false }) // Callback om animatie te beëindigen
            );
        }
    }

    render() {
        const { filters, sorting, query, isLoading, derksPartners, derksPartnersToggle, hasConversionVehicleList } = this.props;
        const { resultsCount, countAnimating } = this.state;

        return (
            <>
                <Modal
                    key="filterModal"
                    open={this.props.modalOpen}
                    title={trans('sulu.content_block.vehicle_overview.filter.title')}
                    handleClose={() => this.props.setModalOpen(false)}
                >
                    <div className="mb-6">
                        <div className="row gutters-1">
                            <div className="col-12">
                                <VehicleOverviewSearch
                                    query={query}
                                />
                            </div>
                        </div>
                        <hr className="my-4" />
                        <VehicleOverviewFilter
                            id="modalFilter"
                            filters={filters}
                        />
                    </div>
                    <div className="vehicle-overview__sticky-filter-button">
                        <div className="sticky-button">
                            <Button
                                text={trans('sulu.content_block.vehicle_overview.filter.close')}
                                theme="base"
                                className={(`btn-block justify-content-between ${isLoading ? 'btn--loader' : ''}`).trim()}
                                icon={{ url: closeIcon }}
                                onClick={() => this.props.setModalOpen(false)}
                            />
                        </div>
                    </div>
                </Modal>
                <div className="pb-4 pb-xl-6 vehicle-overview__header">
                    <div className="row gutters-2 gutters-x-xl-2 gutters-y-xl-0 align-items-center justify-content-between gap-2" ref={this.props.headerRef}>
                        <div className="col-12 col-xl-auto">
                            <p className="h6 pb-2 pb-xl-0 text-base d-flex gap-1">
                                {resultsCount === 0 ?
                                    trans('sulu.content_block.vehicle_overview.header.no_results')
                                    :
                                    <>
                                        <span className={`vehicle-overview__result-counter${countAnimating ? ` animating`: ``}`}>{ resultsCount }</span>
                                        {hasConversionVehicleList ?
                                            <span> {resultsCount === 1 ? trans('sulu.content_block.vehicle_overview.header.result_short') : trans('sulu.content_block.vehicle_overview.header.results_short')}</span>
                                            :
                                            <span> {resultsCount === 1 ? trans('sulu.content_block.vehicle_overview.header.result') : trans('sulu.content_block.vehicle_overview.header.results')}</span>
                                        }
                                    </>
                                }
                            </p>
                        </div>
                        <div className="col-12 col-xl-auto">
                            <div className="row gutters-2">
                                <div className="col-5 d-xl-none order-1">
                                    <Button
                                        text={trans('sulu.content_block.vehicle_overview.filter.title')}
                                        theme="primary"
                                        className="btn-block justify-content-between"
                                        icon={{url: filterIcon}}
                                        onClick={() => this.props.setModalOpen(true)}
                                    />
                                </div>
                                <VehicleOverviewToggles
                                    partnerModalContent={derksPartners}
                                    partnersToggle={derksPartnersToggle}
                                    filters={filters}
                                    reversedState={false}
                                />
                                <div className="col-7 col-xl-auto order-2 order-xl-1">
                                    <VehicleOverviewSorting
                                        sorting={sorting}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
